import { articleIsReadyForPickup } from '@/models/article';
import {
  isArchived,
  isInPaymentStep,
  isInRefundStep,
  RequestWithRelations,
} from '@/models/request';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import CompleteDeliveryPendingClientAction from '@/routes/Requests/Request/components/RequestActionsFooter/components/CompleteDeliveryPendingClientAction';

import { ValidatePaymentAction } from './components/ValidatePaymentAction/ValidatePaymentAction';
import { ValidateRefundAction } from './components/ValidateRefundAction';

export const RequestActionsFooter = ({
  request,
  onActionDone,
}: {
  request: RequestWithRelations;
  onActionDone: () => void;
}) => {
  const { iam } = useRequestContext();

  if (isArchived(request)) {
    return null;
  }

  if (isInPaymentStep(request)) {
    return <ValidatePaymentAction request={request} onActionDone={onActionDone} />;
  }

  if (isInRefundStep(request)) {
    return <ValidateRefundAction request={request} onActionDone={onActionDone} />;
  }

  const areSomeArticlesInPendingClientPickup = request.articles.some(articleIsReadyForPickup);

  if (areSomeArticlesInPendingClientPickup && iam.hasUserScopeOnRequest('store')) {
    return <CompleteDeliveryPendingClientAction request={request} onActionDone={onActionDone} />;
  }

  return null;
};
